/**
 * Licence helpers. The backend sends the licensed modules of the planning area with the
 * profile (`licensedModules`); pages of a missing module are hidden from the menu and show
 * a "not unlocked" page when opened directly. See docs/CONCEPT_Lizenzschluessel.md.
 */

export type LicenseModule = 'SCHEDULING' | 'PLANNING' | 'FORECASTING';

/** Days before expiry from which administrators see a notice (same as the backend). */
export const LICENSE_EXPIRY_NOTICE_DAYS = 14;

type LicensedProfile = {
  licensedModules?: string[];
} | null | undefined;

/**
 * Whether the module is licensed for the current planning area. Routes without a module are
 * always allowed. A profile without `licensedModules` comes from a backend that predates
 * licence keys and is treated as fully licensed, so an older backend keeps working.
 */
export function isModuleLicensed(profile: LicensedProfile, module?: LicenseModule): boolean {
  if (!module) {
    return true;
  }
  if (!profile || !Array.isArray(profile.licensedModules)) {
    return true;
  }
  return profile.licensedModules.includes(module);
}

/** Whole days from today until the given ISO date (negative once it has passed). */
export function daysUntil(isoDate: string, now: Date = new Date()): number {
  const [year, month, day] = isoDate.split('-').map(Number);
  const target = Date.UTC(year, month - 1, day);
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((target - today) / 86_400_000);
}
